/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { Map } from 'mapbox-gl';

export function isMapRemoved(map: Map): boolean {
    // `_removed` is an internal Mapbox flag that guards against operating on
    // a torn-down map. The legacy hook relies on it for HMR stability.
    return (map as unknown as { _removed?: boolean })._removed === true;
}

export function isMapMoving(map: Map): boolean {
    // `isMoving()` reports whether a pan/zoom/rotate animation is in flight.
    // Guard the call since not every (mocked) map implements it.
    const candidate = map as unknown as { isMoving?: () => boolean };
    return typeof candidate.isMoving === 'function' ? candidate.isMoving() : false;
}
